import { apiHelper } from '@/util'

export const siteSettingsService = {
  getDownloadBarVisibility
}

//API URLs
const SITE_SETTINGS = {
  DOWNLOAD_BAR: 'site-settings/download-bar'
}

function getDownloadBarVisibility() {
  return apiHelper().get(`/${SITE_SETTINGS.DOWNLOAD_BAR}`)
}